import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import { Drupal_ParagraphNineteenSocialProof } from '../../../generated/graphql';
import './nineteen-social-proof.scss';
import LazyLoad from 'react-lazyload';
import { Heading } from 'lucid-components-react';

interface Props {
  entity: Drupal_ParagraphNineteenSocialProof;
}

const NineteenSocialProof = ({ entity: { fieldHeader } }: Props) => {
  const {
    allNineteenSocialProofLogosJson: { edges }
  } = useStaticQuery(
    graphql`
      {
        allNineteenSocialProofLogosJson {
          edges {
            node {
              name
              logo
            }
          }
        }
      }
    `
  );

  return (
    <section className="nineteen-social-proof">
      <div className="lucid-container">
        {fieldHeader && (
          <Heading as="h1" variant="subheadS" color="white" mb={8}>
            {fieldHeader}
          </Heading>
        )}
        <ul className="nineteen-social-proof__logos">
          {edges.map(
            ({
              node: { name, logo }
            }: {
              node: { name: string; logo: string };
            }) => (
              <li key={name} className="nineteen-social-proof__logo">
                <LazyLoad offset={200}>
                  <img
                    src={logo}
                    alt={name}
                    className="nineteen-social-proof__image"
                  />
                </LazyLoad>
              </li>
            )
          )}
        </ul>
      </div>
    </section>
  );
};

export default NineteenSocialProof;

export const query = graphql`
  fragment nineteenSocialProof on Drupal_ParagraphNineteenSocialProof {
    fieldHeader
  }
`;
